import { appendSpotlight, fetchSpotlights } from 'utils/api/spotlights.api';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import toast from 'react-hot-toast';

const QUERY_KEY = 'spotlights';

export const useFetchSpotlights = () =>
    useQuery(QUERY_KEY, fetchSpotlights, {
        cacheTime: Infinity,
        staleTime: Infinity,
    });

export const useUpdateSpotlight = () => {
    const qc = useQueryClient();
    return useMutation(appendSpotlight, {
        onSuccess: () => {
            qc.invalidateQueries(QUERY_KEY);
            toast.success('Spotlight Updated!', {
                position: 'top-right',
                autoClose: 3000,
            });
        },
        onError: () => {
            toast.error('Error Updating Spotlight!', {
                position: 'top-right',
                autoClose: 3000,
            });
        },
    });
};
